import { render } from "./DashboardSummary.vue?vue&type=template&id=2b8eda05&scoped=true"
import script from "./DashboardSummary.vue?vue&type=script&lang=js"
export * from "./DashboardSummary.vue?vue&type=script&lang=js"

import "./DashboardSummary.vue?vue&type=style&index=0&id=2b8eda05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8eda05"]])

export default __exports__